import { render, staticRenderFns } from "./BlockType1.vue?vue&type=template&id=2b7db728&scoped=true"
import script from "./BlockType1.vue?vue&type=script&lang=ts"
export * from "./BlockType1.vue?vue&type=script&lang=ts"
import style0 from "./BlockType1.vue?vue&type=style&index=0&id=2b7db728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7db728",
  null
  
)

export default component.exports